import { defaultTheme as medlyDefaultTheme } from '@medly-components/theme';

import { breadcrumb } from './breadcrumb';
import { button } from './button';
import { checkbox } from './checkbox';
import { chip } from './chip';
import colors from './colors';
import { datePicker } from './datePicker';
import { dateRangePicker } from './dateRangePicker';
import font from './font';
import { loader } from './loader';
import { modal } from './modal';
import { multiSelect } from './multiSelect';
import { pagination } from './pagination';
import { radio } from './radio';
import { searchBox } from './searchBox';
import { sideNav } from './sideNav';
import { singleSelect } from './singleSelect';
import { symptomColor } from './symptom';
import { table } from './table';
import { tabs } from './tabs';
import { textField } from './textField';
import { timePicker } from './timePicker';
import { toast } from './toast';
import { toggle } from './toggle';

export const defaultTheme = {
    ...medlyDefaultTheme,
    breadcrumb,
    button,
    checkbox,
    chip,
    colors,
    datePicker,
    dateRangePicker,
    font,
    loader,
    multiSelect,
    pagination,
    radio,
    searchBox,
    sideNav,
    singleSelect,
    symptomColor,
    table,
    tabs,
    textField,
    timePicker,
    toast,
    toggle,
    modal
};

export type Theme = typeof defaultTheme;
